import { memo } from 'react'
import { dispatch } from 'store'
import {
  ButtonWithIcon as StyledButtonWithIcon,
  EmptyTrack as StyledEmptyTrack
} from '../../styled'
import { useTrackHeight } from '../useTrackHeight'
import MediaIcon from 'assets/svgr-icons/Media.svg'

import { editorThunks } from 'store/features/editor/thunks'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { SUB_SIDEBAR_KEYS } from 'consts/sidebar'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

const EmptyTrack = () => {
  const trackHeight = useTrackHeight()
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  const handleAddMediaClick = () => {
    dispatch(
      editorThunks.setActiveSidebarTabAndCloseOverlay(SUB_SIDEBAR_KEYS.UPLOAD)
    )

    if (isMobile) {
      dispatch(editorThunks.setIsMobileSubSidebarOpen(true))
    }
  }

  return (
    <StyledEmptyTrack $height={trackHeight}>
      <StyledButtonWithIcon onClick={handleAddMediaClick}>
        <MediaIcon />
        <span>{translate(T.ADD_MEDIA_LABEL)}</span>
      </StyledButtonWithIcon>
    </StyledEmptyTrack>
  )
}

export default memo(EmptyTrack)
